import React from 'react';
import {useSelector} from 'react-redux';
import {AppState} from '../../../../redux';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import ViewDesktop from './viewDesktop';
import ViewMobile from './viewMobile';

export const AllNews = () => {
  const news = useSelector((state: AppState) => state.news);

  const isDesktop = useIsDesktop();
  const View = isDesktop ? ViewDesktop : ViewMobile;
  return <View news={news} newsNotFound={Boolean(!news.selection.length && news.latest)} />;
};
